export default __webpack_public_path__ + "static/media/rectArrow.3b01d005.svg";